import us from '../../defines';
import RotationDialControl from './rotation-dial-control';
import app from '../../public-api';

const loader = {
  name: 'us:rotation-dial',

  extends: 'viewport',

  dependencies: ['us:user-config'],

  canStart () {
    return us.ENABLEROTATION;
  },

  constructor: RotationDialControl
};

app.plugins.register(loader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/rotation-dial/rotation-dial-loader.js